export const accordionColor = {
    "{D4323099-04F8-48E0-BAF6-82A55ACBD8B8}": "brand.whiteSmoke",
    "{E9B5453E-A571-4E5B-B763-610D2B9B432B}": "brand.lavenderMist",
    "{A5A77893-C416-4F9D-AD73-8279FF638F35}": "brand.eggSour",
} as { [key: string]: string };
